import * as Sentry from '@sentry/react'
import { browserTracingIntegration, replayIntegration } from '@sentry/react'

export function initializeSentry(env: string) {
  if (!env) return
  Sentry.init({
    dsn: 'https://83f5e233190749d68873335604ef2564@o563053.ingest.sentry.io/5723500',
    environment: env || 'production',
    integrations: [
      browserTracingIntegration(),
      //   replayIntegration({
      //     maskAllText: false,
      //     maskAllInputs: false,
      //   }),
    ],
    replaysSessionSampleRate: 1.0,
    replaysOnErrorSampleRate: 1.0,
    tracesSampleRate: 1.0,
    ignoreErrors: ['ResizeObserver loop limit exceeded'],
  })
}
